export const ORGANIZATIONS_PAGE_TITLE = "Organizations";

export const TABLE_HEADERS = {
  NAME: "Name",
  UID: "UID",
  STATUS: "Status",
  CREATED_AT: "Created At",
  NEXT_PAYMENT_DATE: "Next Payment Date",
  USERS_COUNT: "Users Count",
  TARIFF: "Tariff",
};

export const MESSAGES = {
  ERROR: "Failed to load organizations. Please try again later.",
  EMPTY: "No organizations found.",
};
